import { v4 as uuid } from "uuid";
import { Habit, Task } from "./types";

export function createEmptyTask(fields: Partial<Task> & Pick<Task, "order">): Task {
  return {
    type: "task",
    id: uuid(),
    name: "",
    parentId: null,
    isFolder: false,
    disabled: false,
    completed: false,
    condition: null,
    content: [],
    startTime: null,
    endTime: null,
    components: [],
    folders: [],
    goalId: null,
    goalOrder: null,
    isProject: false,
    ...fields,
  };
}

export function createEmptyHabit(fields: Partial<Habit> & Pick<Habit, "order">): Habit {
  return {
    type: "habit",
    id: uuid(),
    name: "",
    isFolder: false,
    disabled: false,
    condition: null,
    content: [],
    startTime: null,
    endTime: null,
    completed: false,
    parentId: null,
    goalId: null,
    goalOrder: null,
    components: [],
    ...fields,
  };
}
